import { Sun, Moon } from "lucide-react";
import { useTheme } from "@/context/ThemeContext";

export default function ThemeToggle() {
  const { theme, toggle } = useTheme();
  const dark = theme === "dark";

  return (
    <button
      onClick={toggle}
      data-testid="theme-toggle"
      aria-label="Ganti tema"
      className="w-full flex items-center justify-between px-3 py-2.5 rounded-lg text-sm text-[#E5E0D8]/70 hover:text-white hover:bg-white/[0.04] transition-colors"
    >
      <span className="flex items-center gap-3">
        <span className="relative w-[18px] h-[18px]">
          <Sun className={`w-[18px] h-[18px] absolute inset-0 transition-all duration-300 ${dark ? "opacity-0 rotate-90 scale-50" : "opacity-100 rotate-0 scale-100"}`} strokeWidth={1.6} />
          <Moon className={`w-[18px] h-[18px] absolute inset-0 transition-all duration-300 ${dark ? "opacity-100 rotate-0 scale-100 text-gold" : "opacity-0 -rotate-90 scale-50"}`} strokeWidth={1.6} />
        </span>
        {dark ? "Mode Gelap" : "Mode Terang"}
      </span>
      <span className={`relative w-10 h-5 rounded-full transition-colors duration-300 ${dark ? "bg-gold" : "bg-white/15"}`}>
        <span className={`absolute top-0.5 w-4 h-4 rounded-full bg-white shadow-md transition-all duration-300 ${dark ? "left-[22px]" : "left-0.5"}`} />
      </span>
    </button>
  );
}
